import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

import 'swiper/css';

export default () => ({
  swiper: null,

  init() {
    if (window.innerWidth >= 1024) {
      return;
    }

    this.swiper = new Swiper(this.$refs.swiper, {
      modules: [Autoplay],
      slidesPerView: 1,
      loop: true,
      speed: 700,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
    });
  },
});